import apiClient from '../utils/axios';

export interface PricingInfo {
  monthly?: {
    unit_amount_dollars: number;
    price_id: string;
    currency: string;
    recurring_interval?: string;
  };
  annual?: {
    unit_amount_dollars: number;
    price_id: string;
    currency: string;
    recurring_interval?: string;
  };
  setup_fee?: {
    unit_amount_dollars: number;
    price_id: string;
    currency: string;
  };
}

export interface PricingData {
  monthlyPricePerFacility: number;
  annualPricePerFacility: number;
  setupFeePerFacility: number;
}

export class PricingService {
  /**
   * Get pricing information from the backend (which fetches from Stripe)
   */
  static async getPricingInfo(organizationId: string, token: string): Promise<PricingData> {
    try {
      // Use the facility billing impact endpoint to get pricing info
      // This endpoint always includes pricing_info from Stripe
      const response = await apiClient.get(
        `/api/organization/${organizationId}/stripe/facility-billing-impact`,
        {
          params: { facility_count: 1 }, // Use 1 as a dummy value to get pricing
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const pricingInfo: PricingInfo = response.data.pricing_info || {};
      
      return {
        monthlyPricePerFacility: pricingInfo.monthly?.unit_amount_dollars || 0,
        annualPricePerFacility: pricingInfo.annual?.unit_amount_dollars || 0,
        setupFeePerFacility: pricingInfo.setup_fee?.unit_amount_dollars || 0,
      };
    } catch (error) {
      console.error('Error fetching pricing info:', error);
      // Return fallback values
      return {
        monthlyPricePerFacility: 0,
        annualPricePerFacility: 0,
        setupFeePerFacility: 0,
      };
    }
  }

  /**
   * Extract pricing data from subscription data (which already includes pricing from backend)
   */
  static extractPricingFromSubscription(subscriptionData: any): PricingData {
    return {
      monthlyPricePerFacility: subscriptionData.monthly_cost_per_facility || 0,
      annualPricePerFacility: (subscriptionData.annual_monthly_cost_per_facility || 0) * 12,
      setupFeePerFacility: subscriptionData.setup_fee_per_facility || 0,
    };
  }
} 